import Spratt12 from './assets/spratt12.jpg';
import christie from './assets/christie.jpg';
import sooz from './assets/sooz.jpg';
import tuan from './assets/tuan.jpg';
import wise from './assets/wise.jpg';
import wedding from './assets/wedding.jpg';
import binni from './assets/binni.jpg';
import monika from './assets/monika.jpg';

export const flowersDB = [
    {
        id: 1,
        picture: Spratt12
    },
    {
        id: 2,
        picture: christie
    },
    {
        id: 3,
        picture: sooz
    },
    {
        id: 4,
        picture: tuan
    },
    {
        id: 5,
        picture: wise
    },
    {
        id: 6,
        picture: wedding
    },
    {
        id: 7,
        picture: binni
    },
    {
        id: 8,
        picture: monika
    }
]